// Override Settings
var bcSfSearchSettings = {
  search: {
    suggestionStyle: '',
    suggestionStyle2MainContainerSelector: '.site-nav-container-last'
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  jQ('.bc-sf-search-suggestion-wrapper ').css('display', '')
};

// Build header of Search result
BCSfFilter.prototype.buildSearchResultHeader = function(data) {
  var searchTerm = this.escape(this.getSearchTerm());
  if (searchTerm !== null && searchTerm != '') {
    var content = data.total_product > 0 ? this.getSettingValue('label.search.resultHeader') : this.getSettingValue('label.search.resultEmpty');
  } else {
    var content = this.getSettingValue('label.search.generalTitle');
  }
  jQ('.' + this.class.searchResultHeader).html(content.replace(/{{ terms }}/g, searchTerm));
};
// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
  var content = '';
  var searchTerm = this.escape(this.getSearchTerm());
  if (searchTerm !== null && searchTerm != '') {
    content = this.getSettingValue('label.search.resultNumber');
    content = content.replace(/{{ count }}/g, '<strong>' + data.total_product + '</strong>').replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>');
  }
  jQ('.' + this.class.searchResultNumber).html(content);
};
// Prepare Params of Suggestion API
BCSfFilter.prototype.prepareSuggestionParams = function() {
  var params = {};
  params.shop = this.shopDomain;
  params.t = new Date().getTime();
  if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
  if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
  // Skip fields
  var skipFields = this.getSettingValue('search.skipFields');
  if (skipFields.length > 0) {
    param.skipFields = skipFields;
  }
  params.callback = 'BCSfSuggestionCallback';
  return params;
};

BCSfFilter.prototype.buildSuggestionProductPrice = function(data) {
  /* Multi-currency Shopify */
  var self = this;
  self.prepareSuggestionProductPriceData(data);

  // Check on sale
  var onSale = data.compare_at_price_min > data.price_min;
  // Format price
  var price = this.formatMoney(data.price_min * 100),
    compareAtPrice = this.formatMoney(data.compare_at_price_min * 100);
  if (this.getSettingValue('search.removePriceDecimal')) {
    price = this.removeDecimal(price);
    compareAtPrice = this.removeDecimal(compareAtPrice);
  }
  // Build Price
  var result = '';
  if (this.getSettingValue('search.showSuggestionProductPrice')) {
    result += '<div class="' + this.class.searchSuggestion + '-product-price">';
    if (onSale) {
      if (this.getSettingValue('search.showSuggestionProductSalePrice')) {
        result += '<s>' + compareAtPrice + '</s>  ';
        result += '<span class="bc-sf-product-sale-price">' + price + '</span>';
      } else {
        result += '<span class="bc-sf-product-sale-price">' + 'Starting at ' + price + '</span>';
      }
    } else {
      result += '<span class="bc-sf-product-regular-price">' + price + '</span>';
    }
    result += '</div>';
  }
  return result;
};


/* Start Search Redirect */
function submitSearchFormMobile(t, e) {
  e.preventDefault();
  var o = bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm);
  o ? window.location.href = o : jQ(t).closest("form").submit()
}

function beforeSubmitSearchForm(t, e) {
  var o = jQ(t).val(),
    i = bcsffilter.getSearchRedirectUrl(o);
  i && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault(), window.location.href = i)
}
BCSfFilter.prototype.setSuggestionPosition = function(t) {
  var e = this;
  if ("function" == typeof getSuggestionPosition && "function" == typeof this.checkIsFullWidthSuggestionMobile) {
    var o = getSuggestionPosition(t),
      i = this.checkIsFullWidthSuggestionMobile(t) ? "top" : "top+12";
    "function" != typeof e.isSuggestionStyle2 || e.isSuggestionStyle2(), "left" == o ? jQ(t).autocomplete("option", "position", {
      my: "left " + i,
      at: "left bottom",
      collision: "none"
    }) : jQ(t).autocomplete("option", "position", {
      my: "right " + i,
      at: "right bottom",
      collision: "none"
    })
  } else "left" == this.getSettingValue("search.suggestionPosition") ? jQ(t).autocomplete("option", "position", {
    my: "left top+12",
    at: "left bottom",
    collision: "none"
  }) : jQ(t).autocomplete("option", "position", {
    my: "right top+12",
    at: "right bottom",
    collision: "none"
  });
  if (jQ(t).length > 0 && jQ(t).on("keydown", function(o) {
      13 == o.keyCode && e.enterSearchBoxEvent(t, o)
    }), jQ(t).closest("form").length > 0) {
    var n = jQ(t).closest("form").find('[type="submit"]');
    n && n.length > 0 && n.each(function(e, o) {
      o.setAttribute("onclick", "beforeSubmitSearchForm('" + t + "', event)")
    })
  }
}, BCSfFilter.prototype.enterSearchBoxEvent = function(t, e) {
  var o = jQ(t).val(),
    i = this.getSearchRedirectUrl(o);
  i && (e.preventDefault(), window.location.href = i)
}, BCSfFilter.prototype.getSearchRedirectUrl = function(t) {
  if (this.suggestionCache && this.suggestionCache.hasOwnProperty(t))
    for (var e = this.suggestionCache[t], o = 0; o < e.length; o++)
      if ("redirect" == e[o].key && e[o].values) {
        var i = e[o].values;
        return i = (i = i.replace("https://" + bcSfFilterMainConfig.shop.domain, "")).replace("http://" + bcSfFilterMainConfig.shop.domain, "")
      } return ""
};
/* End Search Redirect */

// Customize search term
BCSfFilter.prototype.customizeSearchTerm = function(searchTerm) {
  return encodeURIParamValue(searchTerm.replace(/-/g, '').trim());
};

// Close Suggestion Event
BCSfFilter.prototype.closeSuggestionEvent = function(searchBoxId) {
  // Test Mode - Turn on when need check elements of Auto Complete
  // Prevent closing Auto complete when opening Inspect Element
  if (this.getSettingValue('search.suggestionMode') == 'test' || this.checkIsFullWidthSuggestionMobile(searchBoxId)) {
    // if (!jQ('ul.ui-autocomplete').is(":visible")) {
    jQ('.' + this.class.searchSuggestion).show();
    // }
  } else {
    jQ('.' + this.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').siblings().hide();
  }
  jQ('.bc-sf-search-suggestion-wrapper ').css('display', 'none')
  // Always hide loading and show content
  // this.hideSuggestionLoading();
};
// Wrap Suggestion
BCSfFilter.prototype.buildSuggestionWrapper = function(ul, searchBoxId) {
  var self = this;
  var suggestionPosition = getSuggestionPosition(searchBoxId);
  if (self.isSuggestionStyle2()) {
    var suggestionStyle2MainContainerSelector = self.getSettingValue('search.suggestionStyle2MainContainerSelector') || 'header:first';
    jQ(suggestionStyle2MainContainerSelector).css('position', 'relative');
  }
  var wrapperClass = this.class.searchSuggestionWrapper;
  var popoverClass = 'bc-sf-search-suggestion-popover';
  if (!jQ(ul).parent().hasClass(wrapperClass)) {
    var mobileClass = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? this.class.searchSuggestionMobile : '';
    jQ(ul).wrap('<div class="' + wrapperClass + ' ' + mobileClass + '"></div>');
    // Add Arrow
    jQ(ul).parent().prepend('<div class="' + popoverClass + '" data-direction="' + suggestionPosition + '"></div>');
  }
  if (self.isSuggestionStyle2() && jQ('.' + self.class.searchSuggestionWrapper).length > 0) {
    var wrapperSearch = jQ('.' + self.class.searchSuggestionWrapper);
    wrapperSearch.addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle'))
      .addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle') + '-width-fullwidth')
      .addClass(self.class.searchSuggestion + '-products-per-row-' + self.getSettingValue('search.suggestionStyle2ProductPerRow'))
      .addClass(self.class.searchSuggestion + '-reverse-product-block-' + self.getSettingValue('search.suggestionStyle2ReverseProductBlock'));
  }
  jQ(ul).siblings().show();
  // Set open position of parent of Suggestion box
  var topPosition = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? 'top' : 'top+12';
  if (suggestionPosition == 'left') {
    jQ(ul).parent().position({
      my: 'left ' + topPosition,
      at: 'left bottom',
      of: jQ(searchBoxId)[0]
    });
    var buildPopOverClassPosition = function() {
      jQ('.' + popoverClass).position({
        my: 'left+20 top-8' + topPosition,
        at: 'left bottom',
        of: jQ(searchBoxId)[0]
      });
    };
  } else {
    jQ(ul).parent().position({
      my: 'right ' + topPosition,
      at: 'right bottom',
      of: jQ(searchBoxId)[0]
    });
    var buildPopOverClassPosition = function() {
      jQ('.' + popoverClass).position({
        my: 'right-20 top-8',
        at: 'right bottom',
        of: jQ(searchBoxId)[0]
      });
    };
  }
  buildPopOverClassPosition();
  // Set width for wrapper
  if (!self.isSuggestionStyle2()) {
    var width = this.getSuggestionWidth(searchBoxId);
    jQ(ul).parent().outerWidth(width);
  } else {
    jQ(window).resize(function() {
      buildPopOverClassPosition();
    });
  }

  jQ('.bc-sf-search-suggestion-wrapper ').css('display', '');
}

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  var self = this;
  var result = '';
  // Buid Header
  result += this.buildSuggestionHeader(itemInfo['label'], 'product');
  // Build Did you mean
  var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
  if (dym != '') {
    result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
  }
  // Build content
  if (Object.keys(itemData).length > 0) {
    // var count = 0;   
    var k;
    var itemDataLength = itemData.length;
    for (k = 0; k < itemDataLength; k++) {
      // if (count < itemInfo['number']) {
      var product = itemData[k];
      // Get product attributes
      var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
      productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
      var productUrl = this.buildProductItemUrl(product, false);
      if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
        productUrl = Shopify.routes.root.slice(0, -1) + productUrl;
      }
      var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
      var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
      // Get custom class / attribute
      var searchSuggestionClass = this.class.searchSuggestion;
      var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
      result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" data-label="' + this.escape(product['id']) + '" data-value="' + this.escape(product['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
      result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
      // Build Left column
      if (this.getSettingValue('search.showSuggestionProductImage')) {
        result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
      }
      // Build Right column
      result += '<div class="' + searchSuggestionClass + '-right">';
      result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
      if (this.getSettingValue('search.showSuggestionProductSku')) {
        result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
      }
      if (this.getSettingValue('search.showSuggestionProductVendor')) {
        result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
      }
      result += this.buildSuggestionProductPrice(product);
      result += '</div>'; // End Right column
      result += '</a>'; // End a
      result += '</li>'; // End li
      // count++;
      // } else break;
    }
  }
  return result;
};
BCSfFilter.prototype.buildSuggestionPopular = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  var result = '';
  if (Object.keys(itemData).length > 0) {
    // Build content
    var result = this.buildSuggestionHeader(itemInfo['label'], 'popular');
    var itemDataLength = itemData.length;
    var k;
    for (k = 0; k < itemDataLength; k++) {
      // if (k < itemInfo['number']) {
      var searchResult = this.highlightSuggestionResult(itemData[k], searchTerm);
      result += '<li class="' + this.class.searchSuggestionItem + '" data-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]) + '" data-value="' + this.escape(itemData[k]) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]) + '">';
      if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
        result += '<a href="' + Shopify.routes.root.slice(0, -1) + this.buildSearchLink(itemData[k]) + '">' + searchResult + '</a>';
      } else {
        result += '<a href="' + this.buildSearchLink(itemData[k]) + '">' + searchResult + '</a>';
      }
      result += '</li>';
      // }
    }
  }
  return result;
};
BCSfFilter.prototype.buildSuggestionPage = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  var result = '';
  if (Object.keys(itemData).length > 0) {
    // Build content
    var result = this.buildSuggestionHeader(itemInfo['label'], 'page');
    var k;
    var itemDataLength = itemData.length;
    var currentLocale = '';
    if (bcSfFilterMainConfig.general.current_locale && !bcSfFilterMainConfig.general.published_locales[bcSfFilterMainConfig.general.current_locale.toLowerCase()]) currentLocale = '/' + bcSfFilterMainConfig.general.current_locale.toLowerCase();
    for (k = 0; k < itemDataLength; k++) {
      // if (k < itemInfo['number']) {
      var searchResult = this.highlightSuggestionResult(itemData[k]['title'], searchTerm);
      result += '<li class="' + this.class.searchSuggestionItem + '" data-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '" data-value="' + this.escape(itemData[k]['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
      if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
        result += '<a href="' + Shopify.routes.root.slice(0, -1) + itemData[k]['url'] + '">' + searchResult + '</a>';
      } else {
        result += '<a href="' + itemData[k]['url'] + '">' + searchResult + '</a>';
      }
      result += '</li>';
      // }
    }
  }
  return result;
};
BCSfFilter.prototype.buildSuggestionCollection = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  var result = '';
  if (Object.keys(itemData).length > 0) {
    // Build content
    var result = bcsffilter.buildSuggestionHeader(itemInfo['label'], 'collection');
    var k;
    var itemDataLength = itemData.length;
    var currentLocale = '';
    if (bcSfFilterMainConfig.general.current_locale && !bcSfFilterMainConfig.general.published_locales[bcSfFilterMainConfig.general.current_locale.toLowerCase()]) currentLocale = '/' + bcSfFilterMainConfig.general.current_locale.toLowerCase();
    for (k = 0; k < itemDataLength; k++) {
      // if (k < itemInfo['number']) {
      var searchResult = bcsffilter.highlightSuggestionResult(itemData[k]['title'], searchTerm);
      result += '<li class="' + bcsffilter.class.searchSuggestionItem + '" data-label="' + this.escape(itemData[k]['id']) + '" data-value="' + this.escape(itemData[k]['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
      if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
        result += '<a href="' + Shopify.routes.root.slice(0, -1) + '/collections/' + itemData[k]['handle'] + '">' + searchResult + '</a>';
      } else {
        result += '<a href="' + currentLocale + '/collections/' + itemData[k]['handle'] + '">' + searchResult + '</a>';
      }
      result += '</li>';
      // }
    }
  }
  return result;
}
BCSfFilter.prototype.buildSuggestionDidYouMean = function(searchTerm, suggestionData, ul) {
  var result = '';
  if (typeof suggestionData !== 'undefined' && Object.keys(suggestionData).length > 0) {
    var suggestQuery = getValueInObjectArray('suggest_query', suggestionData);
    // Get total products
    var totalProduct = getValueInObjectArray('total_product', suggestionData);
    var prevTotalProduct = getValueInObjectArray('prev_total_product', suggestionData);
    if (prevTotalProduct !== '' && totalProduct > 0) totalProduct = prevTotalProduct;
    // Build Did you mean list
    var dymList = getValueInObjectArray('did_you_mean', suggestionData);
    var dym = '';
    if (dymList != '' && dymList.length > 0) {
      var k;
      var dymListLength = dymList.length;
      for (k = 0; k < dymListLength; k++) {
        if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
          dym += '<a href="' + Shopify.routes.root.slice(0, -1) + this.buildSearchLink(dymList[k]) + '">' + dymList[k] + '</a>';
        } else {
          dym += '<a href="' + this.buildSearchLink(dymList[k]) + '">' + dymList[k] + '</a>';
        }

        if (k < dymList.length - 1) dym += '<span>,</span> ';
      }
    }
    // Build content
    if (suggestQuery != searchTerm) {
      if (totalProduct == 0) result += '<p>' + this.getSettingValue('label.error.noSuggestionProducts').replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>') + '</p>';
      if (suggestQuery != '') {
        var itemUrl = this.buildSearchLink(suggestQuery);
        if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
          itemUrl = Shopify.routes.root.slice(0, -1) + itemUrl;
        }
        result += '<p>' + this.getSettingValue('label.suggestion.suggestQuery').replace(/{{ terms }}/g, '<a href="' + itemUrl + '">' + suggestQuery + '</a>') + '</p>';
      }
      if (dym != '') result += '<p>' + this.getSettingValue('label.suggestion.didYouMean').replace(/{{ terms }}/g, dym) + '</p>';
    }
  }
  return result;
};
// Build View All
BCSfFilter.prototype.buildSuggestionViewAll = function(searchTerm, suggestionData, ul) {
  var headerClass = this.class.searchSuggestionHeader;
  // Build content when total_product > 0
  // If the request is did_you_mean, get the number from suggest_total_product
  var result = '';
  var totalProduct = getValueInObjectArray('total_product', suggestionData);
  var suggestTotalProduct = getValueInObjectArray('suggest_total_product', suggestionData);
  if (suggestTotalProduct !== '') totalProduct = suggestTotalProduct;
  // Check if total_product > display number of products
  var blocks = this.getSettingValue('search.suggestionBlocks');
  var displayProductNumber = getValueInObjectArray('products', blocks, 'type', 'number');
  if (totalProduct > displayProductNumber && totalProduct > 0) {
    result += '<li class="' + headerClass + '-view-all ' + headerClass + '" aria-label="View All">';
    if (Shopify?.routes?.root && (Shopify.routes.root !== '' || Shopify.routes.root !== '/')) {
      result += '<a href="' + Shopify.routes.root.slice(0, -1) + this.buildSearchLink(searchTerm) + '">' + this.getSettingValue('label.suggestion.viewAll').replace(/{{ count }}/g, totalProduct) + '</a>';
    } else {
      result += '<a href="' + this.buildSearchLink(searchTerm) + '">' + this.getSettingValue('label.suggestion.viewAll').replace(/{{ count }}/g, totalProduct) + '</a>';
    }
    result += '</li>';
  }
  return result;
};
BCSfFilter.prototype.prepareSuggestionParams = function(searchTerm, eventType) {
  var params = {};
  params.shop = this.shopDomain;
  params.t = new Date().getTime();
  if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
  var enableFuzzy = this.getSettingValue('search.enableFuzzy');
  if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
  if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
  if (this.getSettingValue('search.reduceMinMatch') !== false) {
    params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
  }
  if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
  // Get product/variant available or not
  if (this.getSettingValue('search.productAvailable') == true) params.product_available = true;
  // Limit
  var blocks = this.getSettingValue('search.suggestionBlocks');
  var k;
  var blocksLength = blocks.length;
  for (k = 0; k < blocksLength; k++) {
      var id = blocks[k]['type'].slice(0, -1);
      params[id + '_limit'] = blocks[k]['number'];
  }
  params['dym_limit'] = this.getSettingValue('search.suggestionDymLimit');
  // Skip fields
  var skipFields = this.getSettingValue('search.skipFields');
  if (skipFields.length > 0) param.skipFields = skipFields;
  params.callback = 'BCSfSuggestionCallback';
  params.event_type = eventType;
  // Suggest types
  var suggestionTypes = eventType == 'suggest_dym' ? ['products'] : this.getSettingValue('search.suggestionTypes');
  params.suggest_types = suggestionTypes;

  params.return_all_currency_fields = false;
  var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();
  params.currency = currentCurrency;
  
  return params;
};